import React, { useEffect, useState } from 'react'
import classNames from 'classnames'
import { isEqual } from 'lodash'
import Dropdown from 'meinian-package/src/baseComponent/dropdown'
import Icon from 'meinian-package/src/component/icon'
import DropDownClearIcon from 'meinian-package/src/baseComponent/dropDownClearIcon'
import styles from './index.module.less'

const findItemByValue = (value, options = []) => {
  const item = options.find(m => isEqual(m.value, value))
  if (item) return item
  // eslint-disable-next-line no-shadow
  for (const item of options) {
    const sonItem = findItemByValue(value, item.children)
    if (sonItem) return sonItem
  }
}
export default (props) => {
  const {
    onChange,
    trigger,
    placement,
    overlayStyle, value, gender, options, placeholder, listClassName, getPopupContainer,
    displayStyle,
  } = props
  const [visible, setVisible] = useState(false)
  const _onChange = (...arg) => {
    onChange?.(...arg)
    setVisible(false)
  }
  return <Dropdown
    overlayStyle={overlayStyle}
    trigger={trigger}
    overlay={<List
      className={listClassName}
      value={value || gender}
      options={options}
      visible={visible}
      onChange={_onChange}
    />}
    visible={visible}
    onVisibleChange={_visible => setVisible(_visible)}
    placement={placement}
    getPopupContainer={getPopupContainer}
  >
    <Display
      style={displayStyle}
      placeholder={placeholder}
      value={value}
      options={options}
      visible={visible}
      gender={gender}
      onClear={() => onChange(undefined, {})}
    />
  </Dropdown>
}

const List = (props) => {
  const {
    className,
    options = [],
    value,
    onChange,
    visible,
    allowClear = true
  } = props
  const [levels, setLevels] = useState([])
  console.log('value', value)
  useEffect(() => {
    setLevels(!value ? [] : getLevels(findItemByValue(value, options)))
  }, [visible])

  return <div className={classNames(styles['mn-cascade'], className)} onClick={e => e && e.stopPropagation()}>
    <div className="cascade-menu">
      {allowClear ? <div
        className={classNames('cascade-item', { active: (value ?? undefined) === undefined })}
        onClick={() => onChange(undefined, {})}
        onMouseEnter={() => setLevels([])}
      >不限</div> : null}
      {options.map(item => <div
        key={item.value}
        className={classNames('cascade-item', { active: isEqual(value, item.value) || levels.includes(item.value) })}
        onClick={() => !item.unSelectable && onChange?.(item.value, item)}
        onMouseEnter={() => {
          setLevels([item.value])
        }}
      >
        {item.label}
        {
          item.children && !!item.children.length && <Icon type="m-Vxing_you" />
        }
      </div>)}
    </div>
    {levels.map((level, index) => {
      const current = options.find(item => item.value === levels[0])?.children || options
      const o = findItemByValue(level, current)?.children || current
      if (!(o && o.length)) return null
      return <div className="cascade-menu">
        {o.map(item => <div
          key={o.value}
          className={classNames('cascade-item', { active: isEqual(value, item.value) || levels.includes(item.value) })}
          onClick={() => {
            !item.unSelectable && onChange?.(item.value, item)
          }}
          onMouseEnter={() => setLevels(pre => [...pre.slice(0, index + 1), item.value])}
        >
          {item.label}
          {
            item.children && !!item.children.length && <Icon type="m-Vxing_you" />
          }
        </div>)}
      </div>
    })}
  </div>
}

const Display = (props) => {
  const { value, gender, options = [], placeholder = '请选择', visible, className, onClear, allowClear = true, customText, onlyShowLeaf, ...otherProps } = props
  const getText = (item) => {
    let text = item.label
    if (onlyShowLeaf) { return text }
    if (item.parent) {
      const t = getText(item.parent)
      text = `${t}-${text}`
    }
    return text
  }
  const text = () => {
    const current = options.find(item => item.value === gender)?.children || options
    if (!value && gender) return gender
    const item = findItemByValue(value, current)
    if (!item) return undefined
    return getText(item)
  }
  return <a className={classNames(styles['mn-cascade-display'], 'dropDownClearIcon', className, { visible, clear: allowClear && (customText?.() || text()), active: (value ?? undefined) !== undefined })} {...otherProps}>
    <DropDownClearIcon visible={visible} onClear={onClear}>
      <span className="text line-1">{customText?.() || text() || placeholder}</span>
    </DropDownClearIcon>
  </a>
}

const getLevels = (item) => {
  if (!item) return []
  const levels = []
  if (item.parent) {
    levels.unshift(item.parent.value)
    const l = getLevels(item.parent)
    if (l.length) {
      levels.unshift(...l)
    }
  }
  return levels
}
